// 記録中のチップ枚数インライン入力（モーダル）
// 記録を終了せずに枚数だけを保存する（保存後はページをリロードして成績表へ反映する）
// モーダルの開閉演出は app/javascript/components/player_select_modal.js と同じ方式
'use strict';

// チップ合計枚数（符号反転）を計算して表示する
// 参照: app/javascript/tip_form.js の calcTotalTip()
function calcChipInlineRemaining() {
  var total = 0;
  $('.chip-inline-number').each(function () {
    var value = parseInt($(this).val(), 10);
    if (!isNaN(value)) {
      total += value;
    }
  });

  var inverted = -total;
  var $remaining = $('#chip-inline-remaining');
  if ($remaining.length) {
    $remaining.text(inverted);
    if (inverted !== 0) {
      $remaining.addClass('text-minus');
    } else {
      $remaining.removeClass('text-minus');
    }
  }
  return inverted;
}

$(document).on('turbolinks:load', function () {
  var $root = $('#chip-inline');
  if ($root.length === 0) return;

  var url = $root.data('url');
  var messages = $root.data('i18n') || {};
  var $modal = $('#chip-inline-modal');
  var $panel = $modal.find('.player-select-modal');
  var $error = $('#chip-inline-error');
  var $saveBtn = $('#chip-inline-save');
  var $closeBtn = $('#chip-inline-close');
  var saveBtnHtml = $saveBtn.html();
  var saving = false;

  // 保存中のローディング表現（players_select_modal.scss の .loading を流用）
  function setSaving(isSaving) {
    saving = isSaving;
    if (isSaving) {
      $saveBtn.css({ width: $saveBtn.outerWidth(), height: $saveBtn.outerHeight() });
      $saveBtn.prop('disabled', true).addClass('loading').empty();
      $closeBtn.prop('disabled', true);
      $('.chip-inline-number').prop('disabled', true);
    } else {
      $saveBtn.prop('disabled', false).removeClass('loading').html(saveBtnHtml).css({ width: '', height: '' });
      $closeBtn.prop('disabled', false);
      $('.chip-inline-number').prop('disabled', false);
    }
  }

  function openModal() {
    $error.hide().text('');
    setSaving(false);
    calcChipInlineRemaining();
    $modal.css('display', 'flex').addClass('starting');
    $panel.addClass('starting');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        $modal.removeClass('starting');
        $panel.removeClass('starting');
        $panel.focus();
      });
    });
  }

  function closeModal() {
    if (saving) return; // 保存中は閉じさせない
    $modal.addClass('starting');
    $panel.addClass('starting');
    var finished = false;
    var end = function () {
      if (finished) return;
      finished = true;
      $modal.off('transitionend', end);
      $modal.hide();
    };
    $modal.on('transitionend', end);
    setTimeout(end, 420);
  }

  $('#chip-inline-open').on('click', openModal);

  $closeBtn.on('click', closeModal);
  // オーバーレイクリックで閉じる
  $modal.on('click', function (e) {
    if (e.target === this) closeModal();
  });
  // ESCで閉じる
  $(document).on('keydown.chipInline', function (e) {
    if (e.key === 'Escape' && $modal.is(':visible')) closeModal();
  });

  $('.chip-inline-number').on('input', calcChipInlineRemaining);

  $saveBtn.on('click', async function () {
    if (saving) return;
    $error.hide().text('');
    setSaving(true);

    var params = new URLSearchParams();
    $('#chip-inline-modal input[type="hidden"], .chip-inline-number').each(function () {
      params.append($(this).attr('name'), $(this).val());
    });

    var token = document.querySelector('meta[name="csrf-token"]');
    try {
      var response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': token ? token.getAttribute('content') : '',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: params.toString()
      });

      if (!response.ok) throw new Error('save failed: ' + response.status);

      Turbolinks.visit(window.location.href, { action: 'replace' });
    } catch (e) {
      console.error('[ChipInline]', e);
      $error.text(messages.save_failed || '').show();
      setSaving(false);
    }
  });
});

// Turbolinks遷移でモーダルが開いたまま残らないようにする
$(document).on('turbolinks:before-cache', function () {
  $('#chip-inline-modal').hide().removeClass('starting');
  $('#chip-inline-modal .player-select-modal').removeClass('starting');
});
